// Stand-in data while the page is UI-only; these become the `fetch` lib's
// response shapes once the real endpoints land.

import type {
  FieldOption,
  ProviderOption
} from "@dealer-center/ddc-pages-nrt-provider-config-tool-interface";
import exampleProvider from "./example_provider.json";
import exampleVin from "./example_vin.json";

// TS's JSON-literal inference collapses to `unknown` for this object's ~108
// heterogeneously-typed entries — pin down the shape explicitly instead.
interface RawProviderField {
  default: string | boolean | null;
  description: string;
  example: unknown;
  required: boolean;
  setByUser: boolean;
  sourceKey: string | null;
  type: string;
}

export const providersFixture: ProviderOption[] = [
  { label: "CVI - SmartPath", value: "cvi_smartpath" },
  { label: "AutoCheck", value: "autocheck" },
  { label: "Experian", value: "experian" }
];

// The example's own id, not a separately made-up one, so the two can't drift.
export const vehicleIdFixture = exampleVin.id;

// A real sellable-vehicles payload; only id/href/inventoryVehicle.id track
// the Vehicle ID field, everything else stays fixed reference data.
export const buildVehicleJson = (vehicleId: string) => ({
  ...exampleVin,
  id: vehicleId,
  href: `https://api.coxautoinventory.com/sellable-vehicles/${vehicleId}`,
  inventoryVehicle: {
    ...exampleVin.inventoryVehicle,
    id: vehicleId
  }
});

// Flattened from example_provider.json's name-keyed object.
export const fieldOptionsFixture: FieldOption[] = Object.entries(
  exampleProvider.providerConfig as Record<string, RawProviderField>
).map(([name, field]) => ({
  label: name,
  value: name,
  default: field.default,
  description: field.description,
  example: field.example,
  required: field.required,
  setByUser: field.setByUser,
  sourceKey: field.sourceKey,
  type: field.type
}));
